import { LoginCommand } from "./commands/LoginCommand";
import { LogoutCommand } from "./commands/LogoutCommand";
import { TokenValidationCommand } from "./commands/TokenValidationCommand";

export class AuthCommandFacade {
  constructor(dispatch, navigate, lang) {
    this.dispatch = dispatch;
    this.navigate = navigate;
    this.lang = lang;
  }

  login(token, path) {
    const command = new LoginCommand(
      token,
      this.dispatch,
      this.navigate,
      path,
      this.lang,
    );
    return command.execute();
  }

  logout() {
    const command = new LogoutCommand();
    return command.execute();
  }

  isTokenValid(token) {
    const command = new TokenValidationCommand(token);
    return command.execute();
  }
}
